<div class="autocomplete autocomplete-icon"
    [ngClass]="{ 'autocomplete--open': showOptions && options?.length > 0, 'margin-bottom-20': !noMargin }">
    <ridango-form-field class="no-margin">
        <input [formControl]="input" ridangoInput autocomplete="off" role="combobox"
            id="{{ autocompleteId }}" class="autocomplete__input" aria-haspopup="true" aria-autocomplete="list"
            (keydown)="handleKeydown($event)" [attr.aria-expanded]="showOptions && options?.length > 0"
            [attr.aria-owns]="optionListId" [attr.aria-controls]="optionListId"
            [attr.aria-activedescendant]="selectedIndex >= 0 ? optionIdPrefix + selectedIndex : null"
            (focus)="showOptions = true" (blur)="markAsTouched()" #inputEl>

        <img class="hide-for-wcag" src="{{ icon }}" alt="" />
        <img class="show-high-contrast-view" src="{{ iconContrast }}" alt="" />

        <ridango-label>{{ label }}</ridango-label>

        <ol role="listbox" id="{{ optionListId }}" class="autocomplete__choices expanded" aria-labelledby="label-1" #items>
            <li *ngFor="let option of options; trackBy:trackByFn; index as i" role="option"
                id="{{ optionIdPrefix + i }}" class="autocomplete__choice"
                [ngClass]="{ 'autocomplete__key': selectedIndex === i, 'autocomplete__choice--full': fullOption }"
                [attr.aria-selected]="selectedIndex === i" (click)="handleOptionClick(option)">
                <mat-icon *ngIf="hasOptionIcon" role="none" aria-hidden="true">
                    {{ optionIconDisplayFn(option) }}
                </mat-icon>
                {{ optionDisplayFn(option) }}
            </li>
        </ol>

        <div *ngIf="hasError" class="ridango-error" role="alert">
            {{ errorMessage }}
        </div>
    </ridango-form-field>
</div>
